<template>
  <div class="flex flex-col items-center justify-center text-white">
    <IconAlertOctagon stroke="1.5" class="mb-16 h-16 w-16 text-white" />
    <h1 class="mb-4 text-2xl font-bold">{{ props.title }}</h1>
    <p class="mx-8 mt-2 text-center text-lg">{{ props.message }}</p>
  </div>
</template>

<script setup lang="ts">
import { IconAlertOctagon } from '@tabler/icons-vue'

export interface ExceptionCard {
  title: string
  message: string
}

const props = defineProps<ExceptionCard>()
</script>
